/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FarmDto } from '../../models/farm-dto';
import { FarmUpdateDto } from '../../models/farm-update-dto';

export interface FarmControllerUpdate$Params {
  id: string;
      body: FarmUpdateDto
}

export function farmControllerUpdate(http: HttpClient, rootUrl: string, params: FarmControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmDto>> {
  const rb = new RequestBuilder(rootUrl, farmControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FarmDto>;
    })
  );
}

farmControllerUpdate.PATH = '/api/farm/{id}';
